import {
  checkinDayOccurrences,
  type CheckinDayItem,
  type CheckinDayLog,
  type CheckinOccurrence,
  type LiveCheckinLog,
} from '@wiztime/core';

/**
 * Log data with the envelope HLC, the shape the occurrence functions read: of a legacy and a new
 * record of one occurrence the newer wins (data dictionary §3.2).
 */
export function dayLogOf(log: LiveCheckinLog): CheckinDayLog & LiveCheckinLog['data'] {
  return { ...log.data, hlc: log.hlc };
}

/**
 * The check-in occurrences of each personal date in `dates` (data dictionary §3.2): due ones and
 * ones done though not due. A transition day of a planned time moved across the day start holds
 * two occurrences of one item. `logs` must cover the dates with two days of margin either side.
 */
export function occurrencesByDate<T extends CheckinDayItem>(
  items: readonly T[],
  logs: readonly LiveCheckinLog[],
  dates: readonly string[],
  dayStartMin: number,
  legacyDayStartMin: number,
): ReadonlyMap<string, readonly CheckinOccurrence<T>[]> {
  const dayLogs = logs.map(dayLogOf);
  return new Map(
    dates.map((date) => [date, checkinDayOccurrences(items, dayLogs, date, dayStartMin, legacyDayStartMin)]),
  );
}
